import { createAction, props } from '@ngrx/store';
import { SparePartWithAvailability } from '../../../../services/spare-part/spare-part.service';
import { prefixed } from '../../../store.helper';

const prefix = '[Spare Part Result]';

export const RECEIVE_SPARE_PARTS_AVAILABILITY = prefixed(prefix, 'Receive spare parts availability');
export const receiveSparePartsAvailability = createAction(
    RECEIVE_SPARE_PARTS_AVAILABILITY,
    props<{ payload: { sparePartsWithAvailability: SparePartWithAvailability[] } }>()
);
